module.exports = __webpack_public_path__ + "img/unlink.fa32dae7.svg";